<!--
  The Nanome mark from public/nanome-logo-icon.svg / nanome-logo-icon-dark.svg (the two files differ only in fill), inlined
  so it works from any asset base (the ChatGPT widget loads from another origin) and filled with currentColor so it takes
  the text colour of the button it sits in, in both themes. Sized like a tabler icon (1em).
-->
<template>
  <svg class="nanome-icon" viewBox="0 0 100 100" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M43.282 34.389a38.253 38.253 0 0 0-29.243 13.563 38.256 38.256 0 0 0-8.5 31.094h29.784a10.212 10.212 0 1 1 15.926 0h29.738a38.257 38.257 0 0 0-37.705-44.657zM77.57 38.383c-3.985-3.985-3.985-10.456 0-14.441 3.985-3.985 10.456-3.985 14.441 0 3.985 3.985 3.985 10.456 0 14.441-3.985 3.985-10.456 3.985-14.441 0z" />
  </svg>
</template>

<style scoped>
.nanome-icon {
  display: inline-block;
  flex-shrink: 0;
  vertical-align: middle;
  /* the mark sits low in its 100x100 box; scale it up a little so it reads at icon size */
  transform: scale(1.25);
}
</style>
